import React, { useState, useEffect } from "react"
import { omitBy, isNull, isEmpty } from "lodash"
import { useTranslation } from "react-i18next"

// UTILITY
import errorHandler from "Utils/error-handler"

// COMPONENTS
import { Col, Row } from "antd"
import {
    Button,
    TextInput,
    SelectInput,
} from "@life-line-lab/components-react"
import { InputNumber } from "antd"
import moment from 'moment';
import { CloseOutlined, PlusCircleOutlined } from "@ant-design/icons"

interface RoutingTimeFormProps {
    onSubmit?: any;
    onUpdate?: any;
    onFetch?: any;
    id?: any;
}

const AddRoutingTimeForm: React.FC<RoutingTimeFormProps> = ({
    onSubmit,
    onUpdate,
    onFetch,
    id,
}) => {
    const initialError = {}
    const initialInput = {
        runTime: [
            {
                startDate: moment().toISOString(),
                startTime: 0,
                Interval: 0,
                active: true
            }
        ],
    }
    const [input, setInput] = useState<any>(initialInput)
    const [error, setError] = useState<any>(initialError)
    const { t } = useTranslation()

    useEffect(() => {
        
    },[input])

    const addRows = () => {
        let runTime = input.runTime.concat({
            startDate: moment().toISOString(),
            startTime: 0,
            Interval: 1,
            active: true
        })
        setInput({ ...input, ["runTime"]: runTime })
    }

    const deleteRows = (index) => {
        let runTimeList = input.runTime
        runTimeList.splice(index, 1)
        setError(initialError)
        setInput({ ...input, ["runTime"]: runTimeList })
    }

    const handleRowInputChange = (value:string, name:string, i: string) => {
        let runTimeList = input.runTime;
        let newValues = JSON.parse(JSON.stringify(runTimeList));
        newValues[i][name] = value;

        setInput({ ...input, runTime: newValues })
        setError(initialError)
    }

    const handleSubmit = () => {
        onSubmit(input)
    }

    return (
        <div>
            <h3>Add time to run algorithm here</h3>
            <h4>Input time as number, from 0 (12am) to 23 (11pm) </h4>
            {input.runTime?.map((time, i) =>
                <div>
                    <Row key={i} justify="start">
                        <Col xs={20} sm={20} md={20}>
                            <InputNumber
                                // label={`Run Time`}
                                min={0}
                                max={23}
                                placeholder={t("txt.enterHere")}
                                value={input.runTime[i].startTime}
                                // name='startTime'
                                onChange={value => handleRowInputChange(value, 'startTime', i)}
                            />
                        </Col>
                        <Col xs={4} sm={4} md={4}>
                            {input.runTime.length > 1
                                ? <CloseOutlined onClick={() => deleteRows(i)} />
                                : <></>
                            }
                        </Col>
                    </Row>

                </div>
            )
            }
            <Button
                size="large"
                type="primary"
                onClick={() => addRows()}
                label={t("label.addField", { field: "time" })}
                icon={<PlusCircleOutlined />}
            />
            <Button
                size="large"
                type="primary"
                onClick={handleSubmit}
                label={id == true
                    ? t("action.update")
                    : t("action.create")
                }
            />
        </div>)
}

export default AddRoutingTimeForm